import React from 'react';
import './cardBlog.scss';

function CardBlog(props){
    const urlApi = "https://jacxdev-backend.herokuapp.com";

    const divcardBlog = {
        backgroundImage: 'url(' + urlApi + props.background + ')'
    }

    return(
        <div className="card custom-card col-md-12 p-0" style={divcardBlog}>
            <div className="card-body">
                <h5 className="card-title"> { props.title } </h5>
                <p className="card-text"> { props.extract } </p>
                <a href="#" className="btn btn-info">LEER MÁS</a>
            </div>
        </div>
    )
}

export default CardBlog;    